import React, { Component } from 'react'
import parse from 'html-react-parser'
import Modal from '../../Modal'

export class About extends Component {   

    constructor(){
        super();
        this.state = {
            open:false
        }
    }

    handleClose = (event) => {
        event.preventDefault()
        this.setState({
            open:false    
        })        
    };
 
    handleOpen = (event) => {   
        event.preventDefault()   
        this.setState({
            open:true    
        })          
    };
   
  render() {
    return (      
        // <!-- About Start -->
        <div className="section techwix-about-section-04 section-padding">
            <div className="shape-1"></div>
            <div className="container">
                {/* <!-- About Wrapper Start --> */}
                <div className="about-wrap">
                    <div className="row">
                        <div className="col-lg-6">
                            {/* <!-- About Content Wrap Start --> */}
                            <div className="about-content-wrap">
                                <div className="section-title">
                                    <h3 className="sub-title">{this.props.aboutcontent.welcome_text}</h3>
                                    <h2 className="title">{this.props.aboutcontent.about_heading}</h2>
                                </div>
                                {parse("<p className=\"text\">" + this.props.aboutcontent.about_us_content + '</p>')}
                                {/* <!-- About Author Info Wrap Start --> */}
                                <div className="about-author-info-wrap">
                                    <div className="about-author">                                        
                                        <h3 className="name">Kalpesh Prajapati</h3>
                                        <span className="designation">CEO</span>
                                    </div>
                                    <div className="about-info">
                                        <p>Call to ask any question </p>
                                        <h3 className="tel:0917992599257">+91 7 99 25 99 25 7</h3>                                        
                                    </div>
                                </div>
                                {/* <!-- About Author Info Wrap End --> */}
                            </div>
                            {/* <!-- About Content Wrap End --> */}
                        </div>
                        <div className="col-lg-6">
                            {/* <!-- About Image Wrap Start --> */}
                            <div className="about-img-wrap">
                                <div className="play-btn-02">
                                <a className="popup-video" href="/" onClick={this.handleOpen}><i className="fas fa-play"></i></a>
                                <Modal isOpen={this.state.open} onClose={this.handleClose}>                   
                                    <>                                   
                                    <iframe  style={{width:'100%', height:'100%'}}  src="https://www.youtube.com/embed/jaYJYpDLB5c?si=aW4DRRD8ZsOOCXuV" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                    </>
                                </Modal>
                                </div>
                                <div className="about-img about-img-big">
                                    <img src={this.props.aboutcontent.about_image_two} alt="" />
                                </div>
                                <div className="about-img about-img-sm">
                                    <img src={this.props.aboutcontent.about_image_one} alt="" />
                                </div>                                
                            </div>
                            {/* <!-- About Image Wrap End --> */}
                        </div>
                    </div>
                </div>
                {/* <!-- About Wrapper End --> */}
                                
        </div>
        
        </div>
        // <!-- About End -->
    )
  }
}

export default About